import axios from "axios";
import {HandlerShowMessage, useShowMessageComponent} from "../assets/js/main";
// import {useLocation, useNavigate} from "react-router-dom";
import {setLoading} from "../redux/loading/actions";
import {useDispatch} from "react-redux";

axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";


const HandleFetchData = () => {
  const {showMessage} = HandlerShowMessage();
  const {showMessageComponent} = useShowMessageComponent()
  const dispatch = useDispatch();

  let loopNo = 0


  const fetchData = async (subDomain, method, url, body, type, params, typeUrl, key) => {
    const handleSetUrl = (e) => {
      switch (e) {
        case 'postex':
          return `https://${subDomain ? (subDomain + '.') : ''}postex.ir`
        case 'postpoint':
          return `https://${subDomain ? (subDomain + '.') : ''}postpoint.ir`
        case 'agent':
          return 'http://192.168.10.85:35590'
        default:
          return `https://${subDomain ? (subDomain + '.') : ''}postex.ir`
      }
    }
    try {
      const response = await axios(`${handleSetUrl(typeUrl)}/api${url}`, {
        method: method,
        data: body,
        params: params,
        headers: {
          "Content-Type": type,
          "token": localStorage.getItem('token') ? localStorage.getItem('token') : '',
          "X-API-KEY": key || ""
        },
      })
      if (response.status === 200) {
        return response?.data
      } else {
        // if(loopNo <= 2){
        //   loopNo += 1
        //   await fetchData(subDomain, method, url, body, type, params, typeUrl, key);
        // }else{
        //   return true
        // }
        console.log('response', response)
      }
    } catch (e) {
      // if(loopNo <= 2){
      //   loopNo += 1
      //   await fetchData(subDomain, method, url, body, type, params, typeUrl, key);
      // }else{
      dispatch(setLoading(false))
      if (!e?.response?.data?.success) {
        if (e?.response?.data?.data?.length > 0){
          await showMessageComponent(e?.response?.data?.data[0]?.errorMessage, 'error')
        }else{
          await showMessageComponent(e?.response?.data?.message, 'error')
        }
      } else if (e?.response?.data && e?.response?.data?.data?.length > 0) {
        e?.response?.data?.data[0]?.errorMessage &&
        await showMessageComponent(e?.response?.data?.data[0]?.errorMessage, 'error')
      } else if (e?.response?.message) {
        e?.response?.message ?
           await showMessageComponent(e?.response?.message, 'error')
           :
           showMessage(e?.response?.status || e?.code)
      } else if (e?.response?.data?.message) {
        await showMessageComponent(e?.response?.data?.message, 'error')
      } else {
        await showMessageComponent(e?.message, 'error')
      }
      // }
    }
  };

  return {fetchData}
}


export default HandleFetchData;

